module.exports = __webpack_public_path__ + "img/32.4bcf8d41.svg";